/** Three cards, each led by a big figure: the trial, the panels, a demo. */
import { ACTIONS } from '../site'

export const PATHS = [
  {
    icon: 'calendar',
    title: 'Free to try',
    stat: '14 days',
    text: 'Create your organization and try every panel free for 14 days.',
    link: ACTIONS.start,
  },
  {
    icon: 'users',
    title: 'One app, every role',
    stat: '4 panels',
    text: 'Your team, reception, HR and admins each get their own panel, all on one schedule.',
    link: { label: 'See the panels', href: '/#panels' },
  },
  {
    icon: 'message',
    title: 'See it with your rooms',
    stat: 'Free demo',
    text: "We'll walk you through MeetNPlan using your own rooms and team.",
    link: ACTIONS.demo,
    dark: true,
  },
]
